import { FC } from 'react';

type PhoneIconProps = {
  width?: number | string;
  height?: number | string;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const PhoneIcon: FC<PhoneIconProps> = ({
  width = 16,
  height = 16,
  color = '#BB9583',
  ...rest
}) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <g clipPath="url(#clip0_4999_886)">
      <path d="M13.6985 10.9948C14.5024 10.227 14.9997 9.16634 14.9997 7.9948C14.9997 6.8232 14.5024 5.76256 13.6985 4.9948M12.333 6.4948C12.7349 6.87867 12.9836 7.409 12.9836 7.9948C12.9836 8.5806 12.7349 9.11094 12.333 9.4948" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M11.6667 4.66666C11.6667 3.09532 11.6667 2.30964 11.1785 1.82148C10.6903 1.33333 9.90467 1.33333 8.33333 1.33333H6.33333C4.76199 1.33333 3.97631 1.33333 3.48815 1.82148C3 2.30964 3 3.09532 3 4.66666V11.3333C3 12.9047 3 13.6903 3.48815 14.1785C3.97631 14.6667 4.76199 14.6667 6.33333 14.6667H8.33333C9.90467 14.6667 10.6903 14.6667 11.1785 14.1785C11.6667 13.6903 11.6667 12.9047 11.6667 11.3333" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.66667 1.33333H6L6.33333 1.99999H8.33333L8.66667 1.33333Z" fill="white" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_4999_886">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

